export function resolveDownloadUrl(url, urlRoot) {
  if (!url) return null;

  let resolved = String(url).trim();

  if (resolved.startsWith("https//")) {
    resolved = "https://" + resolved.slice(7);
  } else if (resolved.startsWith("http//")) {
    resolved = "http://" + resolved.slice(6);
  }

  if (/^https?:\/\//i.test(resolved)) {
    return resolved;
  }

  if (resolved.startsWith("//")) {
    return `https:${resolved}`;
  }

  if (resolved.startsWith("/")) {
    return `${urlRoot}${resolved}`;
  }

  return `${urlRoot}/${resolved}`;
}

export function openDownloadUrl(url, urlRoot) {
  const resolved = resolveDownloadUrl(url, urlRoot);
  if (resolved) {
    window.open(resolved, "_blank");
  }
}
